import { Component } from '@angular/core';

@Component({
    selector: 'app-guitar-app',
    templateUrl: './guitar-app.component.html',
    styleUrls: ['./guitar-app.component.scss'],
    standalone: false
})
export class GuitarAppComponent {}

